import { render, staticRenderFns } from "./carousel-item.component.vue?vue&type=template&id=4a88863e&scoped=true"
import script from "./carousel-item.component.vue?vue&type=script&lang=js"
export * from "./carousel-item.component.vue?vue&type=script&lang=js"
import style0 from "./carousel-item.component.vue?vue&type=style&index=0&id=4a88863e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88863e",
  null
  
)

export default component.exports